import { Component } from '@angular/core';

@Component({
  selector: 'app-change-recovery-number-success',
  imports: [],
  templateUrl: './change-recovery-number-success.component.html',
  styleUrl: './change-recovery-number-success.component.scss',
})
export class ChangeRecoveryNumberSuccessComponent {

}
